module.exports = __webpack_public_path__ + "img/speinshart_fresken.1b21c322.jpg";